import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class ReceivedShipments extends Component {
    static displayName = ReceivedShipments.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            receivedShipments: [],
            selectedShipmentRef: "",
            selectedShipmentId: ""
        }
    }

    componentDidMount() {
        this.loadReceivedShipments();

    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    async loadReceivedShipments() {
        this.state.loading = true;
    
        fetch(`api/Inwards/GetReceivedShipments?warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ receivedShipments: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ receivedShipments: data, alertMessage: "" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Shipments!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Shipments!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ receivedShipments: [], alertMessage: error });
            });
    }

    render() {

        let receivedShipmentsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : (this.state.receivedShipments && this.state.receivedShipments.length > 0 ? this.renderReceivedShipments() : <p>No Shipments</p>);

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Select Shipment</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../Inwards'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {receivedShipmentsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderReceivedShipments() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Shipment Ref </label>
                                <br />
                                <input className="col-sm-4" ref="shipmentRefInput" value={this.state.selectedShipmentRef} onChange={(e) => { this.setState({ selectedShipmentRef: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Shipment Id </label>
                                <br />
                                <input className="col-sm-4" ref="shipmentIdInput" value={this.state.selectedShipmentId} onChange={(e) => { this.setState({ selectedShipmentId: e.target.value }); }} />
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.receivedShipments
                            .filter((item) =>
                            (!this.state.selectedShipmentRef.length ||
                                item.containerNo
                                    .toString()
                                    .toLowerCase()
                                    .includes(this.state.selectedShipmentRef.toString().toLowerCase())
                            )
                            &&
                            (!this.state.selectedShipmentId.length ||
                                item.id
                                .toString()
                                .toLowerCase()
                                .includes(this.state.selectedShipmentId.toString().toLowerCase())
                            )
                        ).map(row =>
                            <tr key={row.id} onClick={() => { this.goto('InwardsImageCapture', row); }}>
                                <td>{row.containerNo}</td>
                                <td>{row.id}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}